/**
 * Accesos a las demas secciones del panel.
 *
 * Es lo que reemplaza a las cuatro "tarjetas de workflow" de
 * `src/gui/views/home_view.py`, pero con una diferencia que no es cosmetica:
 * aquellas EJECUTABAN (`daily_sync`, `full_publication`, `check_services`,
 * `sync_only`) desde un boton en la pantalla inicial. Estas navegan.
 *
 * El motivo: de esos cuatro workflows, dos escriben en cuentas reales de
 * MercadoLibre y ninguno tiene hoy un endpoint que los dispare (la task de sync
 * ni siquiera existe; ver el panel de sincronizacion). Un boton "Publicacion
 * masiva" en la primera pantalla del panel, a un click de distancia y sin
 * ningun paso intermedio, es exactamente el tipo de gatillo que no conviene
 * tener: publicar mal en la cuenta real no se corrige, se da de baja a mano.
 * Encolar una publicacion tiene su propia pantalla, con seleccion de productos
 * y de tienda destino.
 *
 * Sobre las rutas duplicadas
 * --------------------------
 * La fuente de verdad de los paths es `src/components/routes.tsx` (`SECTIONS`).
 * Aca se repiten a mano en vez de importarlas porque ese modulo importa a esta
 * pantalla --es la ruta raiz-- y el import inverso cerraria un ciclo entre los
 * dos archivos. Si un path cambiara alla y no aca, el link no rompe nada: cae
 * en la pantalla de "ruta no encontrada", que se ve.
 */

import { Link } from "react-router-dom";

interface QuickLink {
  readonly to: string;
  readonly label: string;
  readonly hint: string;
}

const LINKS: readonly QuickLink[] = [
  {
    to: "/productos",
    label: "Catalogo",
    hint: "Buscar productos, ver stock y estado, banear y desbanear.",
  },
  {
    to: "/publicaciones",
    label: "Publicacion",
    hint: "Encolar publicaciones hacia la otra tienda y seguir cada corrida.",
  },
  {
    to: "/facturacion",
    label: "Facturacion",
    hint: "Comprobantes AFIP emitidos, con su CAE y su estado de subida a ML.",
  },
  {
    to: "/pricing",
    label: "Pricing",
    hint: "Margen y precio sugerido por producto. Solo lectura.",
  },
  {
    to: "/rentabilidad",
    label: "Rentabilidad",
    hint: "Ranking por margen. No filtra por la tienda seleccionada.",
  },
];

export function QuickLinks() {
  return (
    <nav className="home-links" aria-label="Ir a una seccion">
      {LINKS.map((link) => (
        <Link key={link.to} to={link.to} className="home-link">
          <span className="home-link__label">{link.label}</span>
          <span className="home-link__hint">{link.hint}</span>
        </Link>
      ))}
    </nav>
  );
}
